import { type EnumProcessState, isApproved, isCompleted } from '@Model';
import { useMemo } from 'react';

export function useCanCollect(isCollectible: boolean, totalPrice: number, processState: EnumProcessState) {
    return useMemo(() => {
        const isStatusApproved = isApproved(processState);
        const isStatusCompleted = isCompleted(processState);

        const collectible = isCollectible && !isStatusCompleted;
        const canCollect = collectible && totalPrice !== 0;
        const canApprove = !isCollectible && !isStatusApproved;

        return {
            isStateApproved: isStatusApproved,
            isStateCompleted: isStatusCompleted,
            collectible,
            canCollect,
            canApprove,
        };
    }, [isCollectible, totalPrice, processState]);
}
